export default __webpack_public_path__ + "static/media/filling_7.74ad5a91.jpg";